import { Button, FormNumber, FormRoot, RHF, zodResolver } from "@devhop/ui";
import { z } from "zod";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useTaxSettingsQuery, useUpdateTaxSettings } from "../api/queries";

const TaxSettingsFormSchema = z.object({
  defaultTaxRate: z.number().int().min(0).max(100),
});

type TaxSettingsFormValues = z.infer<typeof TaxSettingsFormSchema>;

export function TaxSettingsPage() {
  const settingsQuery = useTaxSettingsQuery();
  const updateSettings = useUpdateTaxSettings();
  const settings = settingsQuery.data;

  const methods = RHF.useForm<TaxSettingsFormValues>({
    resolver: zodResolver(TaxSettingsFormSchema),
    values: {
      defaultTaxRate: settings?.defaultTaxRate ?? 10,
    },
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຕັ້ງຄ່າພາສີເອກະສານ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">
            ຕັ້ງຄ່າພາສີເອກະສານ
          </h2>
          <p className="text-muted-foreground">
            ກຳນົດ % ພາສີເລີ່ມຕົ້ນ — ເອກະສານແຕ່ລະໃບຍັງເລືອກໄດ້ວ່າໃສ່ພາສີຫຼືບໍ່
          </p>
        </div>

        <div className="max-w-lg rounded-xl border bg-card px-6 py-6">
          {settingsQuery.isLoading ? (
            <p className="text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</p>
          ) : (
            <FormRoot
              methods={methods}
              onSubmit={async (values) => {
                try {
                  await updateSettings.mutateAsync(values);
                } catch {}
              }}
              className="space-y-4"
            >
              <FormNumber
                name="defaultTaxRate"
                label="ອັດຕາພາສີເລີ່ມຕົ້ນ (%)"
                min={0}
                max={100}
              />
              <p className="text-muted-foreground text-xs">
                ເມື່ອສ້າງໃບສະເໜີລາຄາໃໝ່ ລະບົບຈະໃສ່ % ນີ້ໄວ້ລ່ວງໜ້າ (ຍັງປິດພາສີຈົນກວ່າຈະເປີດໃນເອກະສານ)
              </p>
              <div className="flex justify-end">
                <Button type="submit" disabled={updateSettings.isPending}>
                  {updateSettings.isPending ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                </Button>
              </div>
            </FormRoot>
          )}
        </div>
      </Main>
    </>
  );
}
